import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { markControlsAsTouched } from 'src/app/shared/functions/mark-controls-as-touched';
import { AddMedicineStockForm } from '../../forms/add-medicine-stock.form';
import { IAddMedicineStockRequest } from '../../models/use-medicine.model';

export interface AddMedicineStockModalData {
  id: string;
  currentStock: number;
}

@Component({
  selector: 'app-add-medicine-stock-modal',
  templateUrl: './add-medicine-stock-modal.component.html',
  styleUrls: ['./add-medicine-stock-modal.component.scss'],
  standalone: false,
})
export class AddMedicineStockModalComponent implements OnInit, OnDestroy {
  form = new AddMedicineStockForm(this.data.id, this.data.currentStock);
  private subscription = new Subscription();

  constructor(
    public dialogRef: MatDialogRef<AddMedicineStockModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddMedicineStockModalData
  ) {
    this.updateNewStock();
  }

  ngOnInit(): void {
    this.subscription.add(this.form.amount.valueChanges.subscribe(() => this.updateNewStock()));
    this.subscription.add(this.form.expires.valueChanges.subscribe(() => this.updateNewStock()));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  save(): void {
    markControlsAsTouched(this.form);
    if (!this.form.valid) {
      return;
    }

    const result: IAddMedicineStockRequest = {
      id: this.form.id.value,
      amount: Number(this.form.amount.value) || 0,
      reason: this.form.reason.value,
      adjustmentAttachments: this.form.adjustmentAttachments.value ?? [],
      expires: this.form.expires.value,
    };
    this.dialogRef.close(result);
  }

  private updateNewStock(): void {
    const amount = Number(this.form.amount.value) || 0;
    const currentStock = Number(this.form.currentStock.value) || 0;
    const expiry = this.form.expires.value;
    const addsToCurrentStock = !expiry || !this.isExpiredDate(expiry);
    this.form.newStock.setValue(currentStock + (addsToCurrentStock ? amount : 0));
  }

  private isExpiredDate(expiry: Date): boolean {
    return new Date(expiry).getTime() <= Date.now();
  }
}
